export const APP_TYPES = {
  SELLER: "seller",
  EXTERNAL: "external",
};

export const EXTERNAL_HOSTS = ["external.hyperpure.com", "externaldev.hyperpure.com"];

export function getHostname() {
  if (typeof window === "undefined" || !window.location) return "";
  return window.location.hostname || "";
}

export function getPathname() {
  if (typeof window === "undefined" || !window.location) return "";
  return window.location.pathname || "";
}

export function getAppType(hostname = getHostname()) {
  if (EXTERNAL_HOSTS.includes(hostname)) return APP_TYPES.EXTERNAL;

  const override = typeof window !== "undefined" && window.localStorage
    ? window.localStorage.getItem("HP_APP_TYPE_OVERRIDE")
    : null;
  if (override === APP_TYPES.EXTERNAL) return APP_TYPES.EXTERNAL;

  return APP_TYPES.SELLER;
}

export const isExternalApp = () => getAppType() === APP_TYPES.EXTERNAL;
export const isSellerApp = () => getAppType() === APP_TYPES.SELLER;
